import React from "react";
import CtaButton from "../../../components/Buttons/CtaButton/CtaButton";
import StyledH3Heading from "../../../common/components/styledH3Heading/StyledH3Heading";
import CuratedCollectionCarousel from "../../../components/Carousel/CuratedCollection/CuratedCollectionCarousel";
import { useNavigate } from 'react-router-dom';

const styles = {
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "left bottom",
  backgroundImage: "url('/assets/bg-curated-collections.png')",
};

const CuratedCollection = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/collection');
  };
  return (
    <div style={styles} className="w-full flex justify-center">
      <div className="CuratedCollection w-full md:w-[90%] lg:w-[80%] px-5 lg:px-10 pt-14 pb-10 h-full space-y-10">
        <div>
          <StyledH3Heading>Curated Collection</StyledH3Heading>
          <p className="font-inter text-sm font-normal">
            Showing the curated selection of our top Mintable NFTs.
          </p>
        </div>
        <div className="">
          <CuratedCollectionCarousel />
          <div className="hidden md:flex">
            <CtaButton children={"View Collection"} onClick={handleClick}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CuratedCollection;
